/* GI Multimarcas — cross-sell "Complete o look" no carrinho.
   Renderizado por snippets/brand-cart-xsell.liquid dentro de .js-contents:
   o elemento é recriado a cada atualização do carrinho, então
   connectedCallback recarrega as recomendações sozinho. O script é carregado
   FORA da região re-renderizada (cart-drawer.liquid / main-cart-items.liquid)
   porque <script> injetado via innerHTML não executa. */
if (!customElements.get('brand-cart-xsell')) {
  const recommendationsCache = new Map();
  const escapeHtml = (value) =>
    String(value ?? '').replace(
      /[&<>"']/g,
      (c) => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' })[c]
    );

  customElements.define(
    'brand-cart-xsell',
    class BrandCartXsell extends HTMLElement {
      connectedCallback() {
        this.list = this.querySelector('[data-xsell-list]');
        this.inCart = (this.dataset.cartProductIds || '')
          .split(',')
          .map(Number)
          .filter(Boolean);
        // Lazy: o drawer é renderizado em TODA página; só busca recomendações
        // quando o componente fica visível (drawer aberto / página do carrinho).
        if ('IntersectionObserver' in window) {
          const io = new IntersectionObserver((entries) => {
            if (entries.some((e) => e.isIntersecting)) {
              io.disconnect();
              this.load();
            }
          });
          io.observe(this);
        } else {
          this.load();
        }
      }

      async fetchRecommendations() {
        const key = this.dataset.productId;
        if (!recommendationsCache.has(key)) {
          const res = await fetch(
            `${this.dataset.recommendationsUrl}.json?product_id=${key}&limit=8&intent=related`
          );
          if (!res.ok) return [];
          recommendationsCache.set(key, (await res.json()).products || []);
        }
        return recommendationsCache.get(key);
      }

      async load() {
        try {
          const products = (await this.fetchRecommendations())
            .filter((p) => p.available && !this.inCart.includes(p.id))
            .slice(0, 4);
          if (!products.length) return;
          this.list.innerHTML = products.map((p) => this.itemHTML(p)).join('');
          this.hidden = false;
          this.list.querySelectorAll('[data-xsell-add]').forEach((btn) => {
            btn.addEventListener('click', () => this.add(btn));
          });
        } catch (e) {
          /* rede indisponível: some silenciosamente */
        }
      }

      money(cents) {
        const [int, dec] = (cents / 100).toFixed(2).split('.');
        // strip: money_format pode conter HTML (<span class=money>...)
        const format = (this.dataset.moneyFormat || 'R$ {{amount_with_comma_separator}}').replace(/<[^>]*>/g, '');
        const comma = format.includes('comma_separator');
        const grouped = int.replace(/\B(?=(\d{3})+(?!\d))/g, comma ? '.' : ',');
        const amount = format.includes('no_decimals')
          ? grouped
          : comma
            ? `${grouped},${dec}`
            : `${grouped}.${dec}`;
        return format.replace(/\{\{\s*amount[^}]*\}\}/, amount);
      }

      imageUrl(src) {
        if (!src) return '';
        return src + (src.includes('?') ? '&' : '?') + 'width=160';
      }

      itemHTML(p) {
        const variants = p.variants.filter((v) => v.available);
        const select =
          variants.length > 1
            ? `<select class="brand-xsell__variant" aria-label="Opções">${variants
                .map((v) => `<option value="${Number(v.id)}">${escapeHtml(v.title)}</option>`)
                .join('')}</select>`
            : `<input type="hidden" value="${variants[0] ? Number(variants[0].id) : ''}" class="brand-xsell__variant">`;
        const img = p.featured_image
          ? `<a href="${escapeHtml(p.url)}" tabindex="-1"><img src="${escapeHtml(this.imageUrl(p.featured_image))}" alt="" width="64" height="64" loading="lazy"></a>`
          : '';
        return `
          <div class="brand-xsell__item">
            ${img}
            <div class="brand-xsell__meta">
              <a class="brand-xsell__name" href="${escapeHtml(p.url)}">${escapeHtml(p.title)}</a>
              <span class="brand-xsell__price">${escapeHtml(this.money(p.price))}</span>
              ${select}
              <span class="brand-xsell__err" role="alert" hidden></span>
            </div>
            <button type="button" class="brand-xsell__add" data-xsell-add aria-label="Adicionar ao carrinho">+</button>
          </div>`;
      }

      async add(btn) {
        const item = btn.closest('.brand-xsell__item');
        const variantId = Number(item.querySelector('.brand-xsell__variant').value);
        if (!variantId) return;
        btn.disabled = true;
        btn.textContent = '…';
        const drawer = document.querySelector('cart-drawer');
        // captura ANTES do fetch: um add concorrente pode re-renderizar o
        // drawer e desconectar este elemento antes da resposta chegar
        const wasInDrawer = !!this.closest('cart-drawer');
        const body = {
          id: variantId,
          quantity: 1,
          sections: drawer ? drawer.getSectionsToRender().map((s) => s.id) : [],
          sections_url: window.location.pathname,
        };
        try {
          const res = await fetch(this.dataset.cartAddUrl, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', Accept: 'application/javascript' },
            body: JSON.stringify(body),
          });
          const state = await res.json();
          if (state.status) throw new Error(state.description || 'Não foi possível adicionar. Tente de novo.');
          if (drawer && wasInDrawer) {
            drawer.renderContents(state);
          } else {
            window.location.reload();
          }
        } catch (e) {
          btn.disabled = false;
          btn.textContent = '+';
          const err = item.querySelector('.brand-xsell__err');
          if (err) {
            err.textContent = e.message || 'Não foi possível adicionar. Tente de novo.';
            err.hidden = false;
            setTimeout(() => { err.hidden = true; }, 5000);
          }
        }
      }
    }
  );
}
